module.exports = __webpack_public_path__ + "img/ditu.76341707.png";